import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex items-center" };
const _hoisted_2 = { class: "capitalize text-primary font-bold overflow-ellipsis overflow-hidden whitespace-nowrap" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("span", { class: "fas fa-crown text-xs ml-2" }, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_admin_user_overview = _resolveComponent("admin-user-overview");
    const _component_tab_layout = _resolveComponent("tab-layout");
    const _component_invitation_modal = _resolveComponent("invitation-modal");
    const _component_edit_user_modal = _resolveComponent("edit-user-modal");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_tab_layout, null, {
            title: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('user.users')), 1),
                    _hoisted_3
                ])
            ]),
            content: _withCtx(() => [
                _createVNode(_component_admin_user_overview, {
                    class: "px-2",
                    onShowEditUser: _ctx.setEditUser,
                    onShowInvitation: _cache[0] || (_cache[0] = ($event) => (_ctx.showInvitationModal = true))
                }, null, 8, ["onShowEditUser"])
            ]),
            _: 1
        }),
        (_ctx.showInvitationModal)
            ? (_openBlock(), _createBlock(_component_invitation_modal, {
                key: 0,
                admin: "",
                "selected-space": _ctx.selectedWorkspace,
                show: _ctx.showInvitationModal,
                "onUpdate:show": _cache[1] || (_cache[1] = ($event) => ((_ctx.showInvitationModal) = $event)),
                onUserAdded: _ctx.updateUserList
            }, null, 8, ["selected-space", "show", "onUserAdded"]))
            : _createCommentVNode("", true),
        (_ctx.editUserValue)
            ? (_openBlock(), _createBlock(_component_edit_user_modal, {
                key: _ctx.editUserValue,
                user: _ctx.editUserValue,
                show: _ctx.showEditUserModal,
                "onUpdate:show": _cache[2] || (_cache[2] = ($event) => ((_ctx.showEditUserModal) = $event)),
                onClose: _cache[3] || (_cache[3] = ($event) => (_ctx.showEditUserModal = false))
            }, null, 8, ["user", "show"]))
            : _createCommentVNode("", true)
    ], 64));
}
